import { ProductWiseStockReq } from '@gtpl/shared-models/sale-management'
import { SaleOrderService } from '@gtpl/shared-services/sale-management'
import { Button, Card, Col, Form, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const ProductWiseStockReport = () => {
    const saleService=new SaleOrderService()
    const [products,setProducts]=useState<any>()
    const [grade,setGrade]=useState<any>()
    const [productWiseData,setProductWiseData]=useState<any>()

    const {Option}=Select;
    const [form]=Form.useForm()
   
    useEffect(()=>{
        getShortCodesForProductStockReport() 
        getGradesForProductStockReport()
        getProductWiseStockReport()
    },[])

    const getProductWiseStockReport=()=>{
        const req=new ProductWiseStockReq()
        if(form.getFieldValue('product')!='Undefined'){
            req.product=form.getFieldValue('product')
        }
        if(form.getFieldValue('grade')!='Undefined'){
            req.grade=form.getFieldValue('grade')
        }
        saleService.getProductWiseStockReport(req).then((res)=>{
            if(res.status){
                setProductWiseData(res.data)
            }else{
                setProductWiseData([])
            }
        })
    }

    const getShortCodesForProductStockReport=()=>{
        saleService.getShortCodesForProductStockReport().then((res)=>{
            if(res.status){
                const productsData = res.data.filter(productD => productD.product !== null && productD.product!=0);
                setProducts(productsData)
            }else{
                setProducts([])
            }
        })
    }

    const getGradesForProductStockReport=()=>{
        saleService.getGradesForProductStockReport().then((res)=>{
            if(res.status){
                const gradesdata = res.data.filter(gradeD => gradeD.grade !== null && gradeD.grade!=0);
                setGrade(gradesdata)
            }else{
                setGrade([])
            }
        })
    }

    const onReset=()=>{
        form.resetFields()
        getProductWiseStockReport()
    }

    const totals = productWiseData?.reduce(
        (acc, rec) => {
          acc.pendingOrderInKg += parseFloat(rec.pendingOrderInKg) || 0;
          acc.pendingOrderInLbs += parseFloat(rec.pendingOrderInLbs) || 0;
          acc.existingStockInKg += parseFloat(rec.existingStockInKg) || 0;
          acc.existingStockInLbs += parseFloat(rec.existingStockInLbs) || 0;
          acc.requiredStockInKg += parseFloat(rec.requiredStockInKg) || 0;
          acc.requiredStockInLbs += parseFloat(rec.requiredStockInLbs) || 0;
          acc.stockWithoutOrderInKg += parseFloat(rec.stockWithoutOrderInKg) || 0;
          acc.stockWithoutOrderInLb += parseFloat(rec.stockWithoutOrderInLb) || 0;
          return acc;
        },
        {
          pendingOrderInKg: 0,
          pendingOrderInLbs: 0,
          existingStockInKg: 0,
          existingStockInLbs: 0,
          requiredStockInKg: 0,
          requiredStockInLbs: 0,
          stockWithoutOrderInKg: 0,
          stockWithoutOrderInLb: 0,
        }
      );
      
  return (
    <div>
        <Card  title={<span style={{ color: 'white' }}>ORDERS IN HAND REPORT</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
         extra = {
                                    <ReactHTMLTableToExcel
                                    id='excel-button'
                                    className="ant-btn ant-btn-primary"
                                    table='report-table'
                                    filename='orders-in-hand-report'
                                    sheet="orders-in-hand-report"
                                    buttonText='Get Excel'
                                          />
                                         }>
        <Form form={form} onFinish={getProductWiseStockReport}>
                <Row gutter={24}>
                    <Col span={6}>
                    <Form.Item name="product" label="Product" >
                            <Select
                                placeholder="Select Product"
                                showSearch
                                optionFilterProp="children" 
                                filterOption={(input, option) => option.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
                            >
                                {products?.map(dropData => {
                                    return <Option key={dropData.product} value={dropData.product}>{dropData.product}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                    <Form.Item name="grade" label="Grade" >
                            <Select
                                placeholder="Select Grade"
                                showSearch
                                optionFilterProp="children" 
                                filterOption={(input, option) => option.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
                            >
                                {grade?.map(dropData => {
                                    return <Option key={dropData.grade} value={dropData.grade}>{dropData.grade}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                    <Space>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Get Report
                        </Button>
                      </Form.Item>

                      <Form.Item>
                        <Button type="primary" onClick={onReset}>
                          Reset
                        </Button>
                      </Form.Item>
                    </Space>
                  </Col>
                </Row>
            </Form>
            <table id='report-table' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '100%', fontSize: '12px', backgroundColor: '#fff', fontFamily: 'Arial, sans-serif' }}>
                <tr style={{ backgroundColor: 'lightblue' }}>
                <th style={{ textAlign: 'center', fontSize: '18px', border: '1px solid black' }} colSpan={11}>ORDERS IN HAND REPORT</th>
                </tr>
                <tr style={{ backgroundColor: '#d9c0b7' }}>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} rowSpan={2}>S.no</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} rowSpan={2}>Product</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} rowSpan={2}>Grade</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} colSpan={2}>Pending Orders Qty</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} colSpan={4}>Stock Details</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }} colSpan={2}>Stock Without Orders</th>
                </tr>
                <tr style={{ backgroundColor: '#d9c0b7' }}>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>KGS</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>LBS</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>Existing Stock(KG)</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>Existing Stock(LBS)</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>Production Required(KG)</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>Production Required(LBS)</th> 
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>KGS</th>
                <th style={{ textAlign: 'center', fontSize: '14px', border: '1px solid black' }}>LBS</th>
                </tr>
                <tbody>
                {productWiseData?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                         <td style={{ textAlign: 'center', border: '1px solid black' }}>{idx+1}</td>

                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.product}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.grade}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.pendingOrderInKg)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.pendingOrderInLbs)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.existingStockInKg)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.existingStockInLbs)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.requiredStockInKg)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.requiredStockInLbs)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.stockWithoutOrderInKg)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{parseFloat(rec.stockWithoutOrderInLb)?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>

                    </tr>
                )
            })}
                </tbody>
                <tfoot>
  <tr>
    <th style={{ textAlign: 'center', border: '1px solid black' }}></th>
    <th style={{ textAlign: 'center', border: '1px solid black' }}>TOTAL</th>
    <th style={{ textAlign: 'center', border: '1px solid black' }}></th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.pendingOrderInKg.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.pendingOrderInLbs.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.existingStockInKg.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.existingStockInLbs.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.requiredStockInKg.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.requiredStockInLbs.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.stockWithoutOrderInKg.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
    <th style={{ padding: '8px', textAlign: 'right', border: '1px solid black' }}>{(totals?.stockWithoutOrderInLb.toFixed(2))?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
  </tr>
</tfoot>

            </table>
        </Card>
        
    </div>
  )
}

export default ProductWiseStockReport